'use client';

import React, { useState } from 'react';
import { useBodyScrollLock } from '@/components/layout/Header/hooks';
import styles from '@/components/layout/Header/Header.module.css';
import { DesktopHeader } from '@/components/layout/Header/DesktopHeader';
import { MobileHeader } from '@/components/layout/Header/MobileHeader';
import { MobileMenuOverlay } from '@/components/layout/Header/MobileMenuOverlay';

export const InteractiveHeaderWrapper = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openMegaMenu, setOpenMegaMenu] = useState<string | null>(null);

    useBodyScrollLock(isMobileMenuOpen);

    const handleMegaMenuToggle = (menuId: string) => {
        setOpenMegaMenu((prev) => (prev === menuId ? null : menuId));
    };

    return (
        <>
            <header className={styles.header}>
                <DesktopHeader
                    openMegaMenu={openMegaMenu}
                    onMegaMenuToggle={handleMegaMenuToggle}
                />
                <MobileHeader onMenuToggle={() => setIsMobileMenuOpen(true)} />
            </header>
            {isMobileMenuOpen && <MobileMenuOverlay onClose={() => setIsMobileMenuOpen(false)} />}
        </>
    );
};
